import {Box, Stack} from '@chakra-ui/react';
import CustomTab from 'components/CustomTab';
import {useAdminPermissionSettings} from 'hooks/datahook/adminPermission';
import {useAuth} from 'hooks/useAuth';
import {find, get, last, split, trim} from 'lodash';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {Outlet, useMatches, useNavigate} from 'react-router-dom';
import {adminPaths} from 'routes/path';

const CampaignsNewLayout = () => {
    const {t} = useTranslation('app');
    const matches = useMatches();
    const matchPath = get(last(matches), 'pathname');
    const navigate = useNavigate();
    const {roles} = useAuth();
    const {getPermission} = useAdminPermissionSettings({
        roles,
    });
    
    // Check if we're on a create/edit/publish page (hide tabs)
    const isCreatePage = matchPath.includes('/create') || matchPath.includes('/edit') || matchPath.includes('/publish');
    
    const tabs = [
        {
            label: t('campaignList'),
            value: 'campaignList',
            path: adminPaths.informationCampaignsList,
        },
        {
            label: t('campaignTemplates'),
            value: 'campaignTemplates',
            path: adminPaths.informationCampaignsTemplates,
        },
        {
            label: t('registeredLeads'),
            value: 'registeredLeads',
            path: adminPaths.informationCampaignsNewRegisteredLeads,
        },
        {
            label: t('convertedClientsNew'),
            value: 'convertedClientsNew',
            path: adminPaths.informationCampaignsNewConvertedClients,
        },
        {
            label: t('campaignSharedLogs'),
            value: 'campaignSharedLogs',
            path: adminPaths.informationCampaignsNewSharedLogs,
        },
        {
            label: t('campaignAccessLogsNew'),
            value: 'campaignAccessLogsNew',
            path: adminPaths.informationCampaignsNewAccessLogs,
        },
        {
            label: t('campaignBenefitsLogs'),
            value: 'campaignBenefitsLogs',
            path: adminPaths.informationCampaignsNewBenefitsLogs,
        },
    ];
    
    // Find the active tab by checking if matchPath starts with the tab's path
    // This handles both exact matches and nested routes (e.g., /templates and /templates/create)
    const value =
        find(tabs, (o) => matchPath === o.path || matchPath.startsWith(o.path + '/'))?.value || tabs[0]?.value;

    return (
        <Stack spacing={4}>
            {!isCreatePage && (
                <CustomTab
                tabs={tabs}
                tabOnly
                value={value}
                onChange={(v) => {
                    navigate(find(tabs, (o) => o.value === v)?.path);
                }}
                />
            )}
            <Box width={'100%'}>
                <Outlet />
            </Box>
        </Stack>
    );
};

export default CampaignsNewLayout;
